import * as Scrivito from "scrivito";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";
import IconForObjClass from "../../utils/IconForObjClass";

Scrivito.provideComponent("LinkWidget", ({ widget }) => {
  const link = widget.get("link");
  let icon = "angle-right";
  if (link) {
    icon = IconForObjClass(
      link.isExternal() ? "external" : link.obj().objClass()
    );
  }

  if (!link) {
    return (
      <Scrivito.WidgetTag tag="li">
        <InPlaceEditingPlaceholder>
          Provide a link in the widget properties.
        </InPlaceEditingPlaceholder>
      </Scrivito.WidgetTag>
    );
  }

  return (
    <Scrivito.WidgetTag tag="li">
      <Scrivito.LinkTag
        to={link}
        title={icon === "download" ? "Download" : null}
      >
        <i className={`las la-${icon} me-2`} />
        <LinkTitle link={link} />
      </Scrivito.LinkTag>
    </Scrivito.WidgetTag>
  );
});

function formatBytes(bytes) {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const units = ["B", "KB", "MB", "GB", "TB", "PB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = bytes / k ** i;
  return `${size.toFixed(2)} ${units[i]}`;
}

const LinkTitle = Scrivito.connect(({ link }) => {
  const additionalInformation = link.obj()?.isBinary()
    ? ` | ${formatBytes(link.obj().get("blob").raw().contentLength())}`
    : "";

  let title = link.title();

  if (link.isExternal() && !title) {
    title = link.url();
  }

  if (link.isInternal() && !title) {
    title = link.obj().get("title");
  }

  return `${title}${additionalInformation}`;
});
